import { createClient } from "@supabase/supabase-js";

export const supabase = createClient(
  'https://pwtpkigmcxvngmmcnfft.supabase.co',
  'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InB3dHBraWdtY3h2bmdtbWNuZmZ0Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzkxMDQyMTgsImV4cCI6MjA5NDY4MDIxOH0.n7yQI6Tat-0B0Eu9C6kFCWqDUderkhKbkPwxts66YMs'
);
